import { copyToClipboard } from '~/features/apps/utils/appsUtils';
import FieldOrNoData from '~/features/base/components/FieldOrNoData';
import DeviceHealthState from '~/features/devices/components/DeviceHealthState';
import SoftwareVersion from '~/features/base/components/SoftwareVersion';
import InstallationStatusLabel from '~/features/campaigns/components/campaign/CampaignStages/InstallationStatusLabel';
import { FormattedTime } from 'react-intl';
import DeviceOffline from '~/features/devices/components/DeviceOffline';
import React from 'react';

const copyClipboard = (field) => (
    <span key='field' className='rioglyph rioglyph-duplicate text-color-dark text-size-15 padding-left-5'
          onClick={(event) => {
              event.stopPropagation();
              copyToClipboard(field, true);
          }}></span>);

export const devicesDescriptors = [
    {
        id: 'stage',
        field: 'stageOrder',
        label: 'intl-msg:stage',
        format: (field) => (
            <span className='margin-right-5'>
                <FieldOrNoData field={field}/>
            </span>
        )
    },
    {
        id: 'deviceId',
        field: 'serialNumber',
        label: 'intl-msg:deviceId',
        format: (field) => (
            <span className='white-space-nowrap'>
            <span className='margin-right-5'>
            <FieldOrNoData field={field}/>
    </span>
                {copyClipboard(field)}
    </span>
        ),
    }, {
        id: 'vin',
        field: 'vin',
        label: 'intl-msg:VIN',
        className: 'hidden-xs hidden-ls hidden-sm',
        format: field => [<FieldOrNoData key='fieldOrNoData' field={field}/>,
            field && copyClipboard(field),
        ],
    }, {
        id: 'deviceHealthState',
        field: 'health',
        label: 'intl-msg:deviceHealthState',
        format: (field, item) =>
            [<DeviceHealthState controlDevice={item}/>],

    }, {
        id: 'softwareVersion',
        field: 'lastDistroVersionReported',
        label: 'intl-msg:softwareVersion',
        className: 'hidden-xs hidden-ls hidden-sm',
        format: (field, item) => <SoftwareVersion item={item}/>,
    },
    {
        id: 'installationStatus',
        field: 'installationStatus',
        label: 'intl-msg:InstallationStatus',
        className: 'hidden-xs hidden-ls hidden-sm',
        format: (field, _) => <InstallationStatusLabel status={field}/>,
    },
    {
        id: 'lastCheckForUpdateTimestamp',
        field: 'lastCheckForUpdateTimestamp',
        label: 'intl-msg:lastCheckForUpdateTimestamp',
        format: field => {
            return (
                <span className='white-space-nowrap'>
        <FieldOrNoData field={field ? <FormattedTime value={field} year='numeric'
                                                     month='2-digit' day='2-digit'/> : null}/>
    <DeviceOffline timestamp={field}/>
    </span>
            );
        },
        sortable: true,
    }, {
        id: 'registrationTimestamp',
        field: 'registrationTimestamp',
        label: 'intl-msg:registrationTimestamp',
        className: 'hidden-xs hidden-ls hidden-sm hidden-md',
        format: field => {
            return (
                <FieldOrNoData field={field ? <FormattedTime value={field} year='numeric'
                                                             month='2-digit' day='2-digit'/> : null}/>
            );
        },
        hidden: true,
    },
];
